<template>
  <yxt-drawer
    :title="$t('pc_biz_title_select_dimension').d('选择维度')"
    size="960px"
    :visible.sync="isShow"
    :before-close="beforeClosDialog"
    class="yxtbiz-select-dimension"
  >
    <div v-if="!isEmpty" class="yxtbiz-select-dimensional__content">
      <dimensional-list :name="name" class="mb16">
        <div class="flex">
          <div
            v-for="item in jqTypes.slice(0, -1)"
            :key="item.id"
            class="flex align-items-center mr16"
          >
            <point-label
              :name="item.name"
              :type="item.id"
              :is-left="true"
            />
          </div>
        </div>
      </dimensional-list>
      <template v-for="jq in jqDimBeans" >
        <dimensional-list v-if="jq.show" :key="jq.id" :name="jq.itemCustomName" class="sub-bean">
          <template v-for="sub in jq.subJqDimBeans">
            <div v-if="sub.show" :key="sub.id" class="sub-bean">
              <point-label
                :name="sub.itemCustomName"
                :type="sub.itemType"
              />
              <dimensional-box
                :isForm="isForm"
                :list="sub.jqRequireDetailBeans"
                :rtModelDetail="rtModelDetail"
                :skillModelDetail.sync="skillModelDetail"
                :defaultCheckedKeys="defaultCheckedKeys"
                :checkedKeys.sync="checkedKeys"
                class="mt8"
              />
            </div>
          </template>
        </dimensional-list>
      </template>
    </div>
    <div v-else class="yxtbiz-select-dimensional__empty">
      <img :src="`${this.$staticBaseUrl}ufd/c4d5f9/talentrv/pc/img/sp-exmpt.png`" class="yxtbiz-select-dimensional__empty__img">
      <span class="yxtbiz-select-dimensional__empty__text mt16">{{ $t('pc_biz_msg_no_dimension_rule').d('暂无设置规则的维度，请前往任职资格进行管理查看') }}</span>
    </div>
    <div slot="footer">
      <yxt-button
        plain
        @click="isShow = false"
      >
        {{ $t('pc_biz_core_btn_cancel').d('取消') }}
      </yxt-button>
      <yxt-button
        type="primary"
        @click="onComplete"
      >
        {{ $t('pc_biz_common_btn_sure').d('确定') }}
      </yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import dimensionalList from './components/dimensional-list';
import dimensionalBox from './components/dimensional-box';
import pointLabel from './components/point-label';
import { getJqDim } from './service.js';
import { jqTypes } from './components/enum';
import mixins from './components/mixins';

export default {
  name: 'YxtbizSelectDimension',
  components: { dimensionalList, dimensionalBox, pointLabel },
  mixins: [mixins],
  props: {
    isForm: {
      type: Boolean,
      default: false
    },
    checkList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isShow: false,
      jqTypes: jqTypes,
      name: '',
      props: {
        label: 'name',
        children: 'subTasks'
      },
      defaultCheckedKeys: [], // 默认选中
      checkedKeys: [], // 任务模型选中的
      jqDimBeans: [], // 维度集合
      skillModelDetail: null, // 能力模型
      rtModelDetail: null, // 任务模型
      isEmpty: true // 是否无可用维度
    };
  },
  methods: {
    async open(id, taskId) {
      await this.getJqDetail(id, taskId);
      this.hasFormInfo = this.useFormChange(this.checkList.map(item => item.jqDimId));
      this.isShow = true;
    },
    beforeClosDialog(done) { // 弹框关闭之前的判断
      const list = this.getData();
      let state = this.hasFormInfo(list.map(item => item.jqDimId));
      this.beforeCloseMixin(state, done);
    },
    async getJqDetail(id, taskId) {
      const checkList = this.checkList.map(check => check.jqDimId) || [];
      const res = await getJqDim(id, {
        taskId: taskId || ''
      }).catch(err => {
        this.$sendErrMsg(err);
      });
      this.checkedKeys = checkList.concat(res.disableJqDimIds);
      this.isEmpty = true;
      // 处理维度数据
      if (res.jqDimBeans) {
        res.jqDimBeans.forEach(item => {
          item.show = false;
          if (item.subJqDimBeans) {
            item.subJqDimBeans.forEach(sub => {
              sub.show = false;
              if (sub.jqRequireDetailBeans) {
                sub.jqRequireDetailBeans.forEach(jq => {
                  const isDisabled = res.disableJqDimIds.includes(jq.id);
                  const isChecked = checkList.includes(jq.id);
                  jq.checked = isDisabled || isChecked;
                  // 动态匹配不展示没有配置规则的，表单匹配不展示配置规则的
                  if (((this.isForm && !jq.ruleId) || (!this.isForm && jq.ruleId)) && jq.rangeType !== 8) {
                    sub.show = true;
                    item.show = true;
                    this.isEmpty = false;
                  }
                });
              } else {
                sub.jqRequireDetailBeans = [];
              }
            });
          } else {
            item.subJqDimBeans = [];
          }
        });
      } else {
        res.jqDimBeans = [];
      }
      // 处理能力模型数据
      if (res.skillModelDetail && res.skillModelDetail.jqSkillCatalogs) {
        res.skillModelDetail.jqSkillCatalogs.forEach(item => {
          item.skillModelClassifications = item.skillModelClassifications.map(skill => {
            if (skill.family === 2) {
              return {
                ...skill,
                checked: this.isForm ? (res.disableJqDimIds.includes(skill.skillId) || checkList.includes(skill.skillId)) : false
              };
            } else {
              let skillModelMaps = skill.skillModelMaps.map(model => ({
                ...model,
                checked: this.isForm ? (res.disableJqDimIds.includes(model.skillId) || checkList.includes(model.skillId)) : false
              }));
              return {
                ...skill,
                skillModelMaps
              };
            }
          });
        });
      }
      // 处理任务模型数据
      const flattenTasks = (tasks) => {
        tasks.forEach(task => {
          task.disabled = res.disableJqDimIds.includes(task.rtId);
          if (task.subTasks && task.subTasks.length) {
            flattenTasks(task.subTasks);
          }
        });
      };
      if (res.rtModelDetail) {
        flattenTasks(res.rtModelDetail.rtList);
      }
      const { disableJqDimIds, skillModelDetail, rtModelDetail, jqName, jqDimBeans } = res;
      this.defaultCheckedKeys = disableJqDimIds;
      this.skillModelDetail = skillModelDetail;
      this.rtModelDetail = rtModelDetail;
      this.name = jqName;
      this.jqDimBeans = jqDimBeans || [];
    },
    getData() {
      let skillList = [];
      let rtList = []; // 任务模型数据
      let jqCheckList = [];
      let perList = [];
      // 表单匹配需要处理任务模型和能力模型数据
      if (this.isForm) {
        if (this.skillModelDetail) {
          // 处理能力模型
          skillList = this.skillModelDetail.jqSkillCatalogs.flatMap(item => item.skillModelClassifications).reduce((acc, item) => {
            if (item.family === 2) {
              return [...acc, item];
            } else {
              return [...acc, ...item.skillModelMaps];
            }
          }, []).filter(check => check.checked).map(skill => ({
            dimName: skill.name,
            jqDimId: skill.skillId,
            dimType: 4,
            jqSkillModelId: this.skillModelDetail.modelId,
            dimCategoryName: this.skillModelDetail.modelName
          }));
        }
        // 处理任务模型数据
        const flattenTasks = (tasks) => {
          tasks.forEach(task => {
            rtList.push(task);
            if (task.subTasks && task.subTasks.length) {
              flattenTasks(task.subTasks);
            }
          });
        };
        if (this.rtModelDetail) {
          flattenTasks(this.rtModelDetail.rtList);
          perList = rtList.filter(item => this.checkedKeys.includes(item.rtId)).map(checked => ({
            dimName: checked.name,
            jqDimId: checked.rtId,
            dimType: 5,
            jqRtModelId: this.rtModelDetail.modelId,
            dimCategoryName: this.rtModelDetail.modelName
          }));
        }
      }
      // 处理维度数据
      this.jqDimBeans.forEach(jq => {
        jq.subJqDimBeans && jq.subJqDimBeans.forEach(sub => {
          const checkList = sub.jqRequireDetailBeans && sub.jqRequireDetailBeans.filter(bean => bean.checked).map(item => ({
            dimName: item.itemValue,
            jqDimId: item.id,
            dimType: item.rangeType,
            dimCategoryName: sub.itemCustomName
          }));
          jqCheckList.push(...checkList);
        });
      });
      // 去除不可选的，返回最终的数据
      const list = [...jqCheckList, ...perList, ...skillList].filter(item => !this.defaultCheckedKeys.includes(item.jqDimId));
      return list;
    },
    onComplete() {
      const list = this.getData();
      const checkList = this.checkList.filter(item => this.defaultCheckedKeys.includes(item.jqDimId)) || [];
      this.$emit('complete', this.isEmpty ? [] : [...list, ...checkList]);
      this.isShow = false;
    }
  }
};
</script>
